// hooks/useCreateNewReservation.ts
import { useDispatch, useSelector } from 'react-redux';
import { baseStore, RootState } from '../store'; // Adjust the import based on your file structure
import Logger from '../helpers/logger';
import ErrorTracker from '../helpers/errorTracker';
import { setGroupsByLocation, groupsLoadFailed, groupsLoadStarted } from '../slice/bookingCreation/bookingCreationSlice';
import { locationsApiSlice } from '../../api/locations/locationsApiSlice';
import { notifyLoadFailure, queryResultError } from '../helpers/failureNotification';


const fetchGroupsCall = async(locationId: string, types?: string) => {
    const data = await baseStore.dispatch(
        locationsApiSlice.endpoints.getLocationEquipment.initiate({
            locationId: locationId,
            types
        })
    )
    return data;
};

export const useFetchGroups = (types?: string) => {
  const selectedLocation = useSelector((state: RootState) => state.bookingCreation.selectedLocation);
  const dispatch = useDispatch();

  const fetchGroups = async () => {
    try {
        if (selectedLocation){
            dispatch(groupsLoadStarted());
            const result = await fetchGroupsCall(selectedLocation.id, types);
            // `initiate` resolves with `{ error }` instead of throwing: a
            // failed load used to leave the selection step spinning (#1970).
            const failure = queryResultError(result);
            if (failure) {
                Logger.for('fetchGroups').error(failure);
                ErrorTracker.trackException(failure as Error);
                dispatch(groupsLoadFailed(selectedLocation.id));
                notifyLoadFailure(dispatch, 'book_location.error.fetch_equipment');
            }
            if (result.data) {
                dispatch(setGroupsByLocation({ locationId: selectedLocation.id, groups: result.data }))
            }
        }
    } catch (error) {
      Logger.for('createNewReservation').error(error);
      ErrorTracker.trackException(error as Error);
      if (selectedLocation) {
        dispatch(groupsLoadFailed(selectedLocation.id));
      }
      notifyLoadFailure(dispatch, 'book_location.error.fetch_equipment');
    }
  };

  return fetchGroups;
};
